import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ResponseApiCalls } from "../../apis/ResponseApiCalls";
import { formatErrorLog, notifyError } from "../../utils/helpers";
import styles from "./EmbeddedPollGuide.module.css";
import { ReactComponent as ILLUSTRATION_ICON } from "./images/cardIllustration.svg";
import { ReactComponent as TITLE_ICON } from "./images/cardTitleIcon.svg";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { useTranslation } from "react-i18next";

export default function EmbeddedPollGuide({ setPageIdentifier }) {
    const { t } = useTranslation();
    const {width} = useWindowDimensions();
    const { getPollRecordFromUniqueCode} = ResponseApiCalls();
    const { pollCode } = useParams();
    const history = useHistory();
    const [lmsLink, setLmsLink] = useState("");

    useEffect(() => {
        setPageIdentifier(t("integration.embeddedPollPageIdentifier"));
        getPollRecordFromUniqueCode(pollCode).then(result => {
            if (!result || !result.poll || !result.poll.lmsHomeUrl) {
                notifyError(t("poll.invalidActivityCode"));
                formatErrorLog(t("poll.invalidActivityCode"));
                history.push("/");
                return;
            }

            setLmsLink(result.poll.lmsHomeUrl);
        });
        // setLmsLink("https://www.google.com");
    }, []);

    return (
        <div className={styles.container}>
            <span className={styles.title}>{t("integration.embeddedPollTitle")}</span>
            <div className={styles.card}>
                <div className={styles.cardTitleBox}>
                    <TITLE_ICON style={{marginRight: 10}}/>
                    <div className={styles.cardTitleText}>{t("integration.embeddedPollGuideTitle")}</div>
                </div>
                <div
                    className={styles.cardBody}
                    style={{
                        width: Math.min(width * 0.8, 1000),
                        flexDirection: width > 500 ? "row" : "column",
                        alignItems: "center",
                        gap: 15
                    }}
                >
                    <div style={{display: "flex", flexDirection: "column", flex: 1}}>
                        <span className={styles.steps} style={{marginBottom: 20}}>{t("integration.embeddedPollGuideDescription")}</span>
                        <span className={styles.steps}>{t("integration.embeddedPollGuideStep1Prefix")} <span className={styles.link} onClick={() => window.open(lmsLink, "_blank")}>{t("integration.embeddedPollGuideStep1Suffix")}</span></span>
                        <span className={styles.steps}>{t("integration.embeddedPollGuideStep2")}</span>
                        <span className={styles.steps}>{t("integration.embeddedPollGuideStep3")}</span>
                    </div>
                    { width > 500 && <ILLUSTRATION_ICON/>}
                </div>
            </div>
            <div style={{flex: 1}}/>
        </div>
    );
}